export default __webpack_public_path__ + "static/media/StoreFront.300d91db.jpg";